import React from 'react';
// import { Typography, Box } from '@mui/material';
import SchoolIcon from '@mui/icons-material/School';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import StudentTutionFee from './StudentTutionFee';
import StudentOtherFees from './StudentOtherFees';
import ReusableTabs from '../../../components/UIElements/ReusableTabs';
import TotalFeesList from './TotalFeesList';
export default function StudentFeeDetails({ StudentId }) {
  const FeeTypesTabs = [
    {
      label: 'Tution Fees',
      icon: <SchoolIcon className='size-8 ' />,
      content: <StudentTutionFee StudentId={StudentId} />,
    },
    {
      label: 'Enter Additional Fees',
      icon: <AccountBalanceWalletIcon className='size-8 ' />,
      content: <TotalFeesList StudentId={StudentId} />,
    },
    {
      label: 'Pay Additional Fees',
      icon: <ReceiptLongIcon className='size-8 ' />,
      content: <StudentOtherFees StudentId={StudentId} />,
    },
  ].filter(Boolean);
  return (
    <>
      <div className='min-h-[75vh]'>
        {/* <Box className='bg-blue-50 p-4 rounded-lg'>
          <Typography variant='h6' className='text-blue-700 font-bold'>
            Settings & Academic Structure
          </Typography>
          <Typography variant='body1' className='text-gray-600'>
            Manage Academic Structure, Notifications and Application Info
          </Typography>
        </Box> */}
        <ReusableTabs
          tabs={FeeTypesTabs}
          variant='scrollable'
          allowScrollButtons={true}
          className='w-full'
          defaultTab={0}
        />
      </div>
    </>
  );
}
